import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { NotificationService } from '../../services/notification.service';
import {
  BsDatepickerConfig,
  BsDatepickerViewMode,
} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-application-form',
  templateUrl: './application-form.component.html',
  styleUrl: './application-form.component.scss',
})
export class ApplicationFormComponent implements OnInit {
  registrationForm: FormGroup;
  submitted = false;
  isLoading: boolean = false;
  public stateList: any = [];
  public cityList: any = [];
  cityLists: any[][] = [];

  otherChecked = false;
  selectedBrands: string[] = [];
  selectedBusinessTypes: string[] = [];
  selectedExpectations: string[] = [];

  bsConfig: Partial<BsDatepickerConfig>;
  minMode: BsDatepickerViewMode = 'year';

  vehicleBrands = [
    'MARUTI SUZUKI',
    'HONDA',
    'KIA',
    'HYUNDAI',
    'TOYOTA',
    'VOLVO',
    'TATA',
    'NISSAN',
    'BMW',
    'MAHINDRA',
    'RENAULT',
    'AUDI',
    'CHEVROLET',
    'VOLKSWAGEN',
    'JEEP',
    'FIAT',
    'SKODA',
    'JLR',
    'FORD',
    'MG MOTOR',
    'MERCEDES',
  ];

  expectations = [
    'Parts Sourcing at Better Rates',
    'Customer Inflow Support',
    'Insurance Tie-ups',
    'Digital Tools for Billing/Inventory',
    'EV Servicing Readiness',
    'Credit Facilities (BNPL / Working Capital)',
  ];

  businessTypes = [
    'General Mechanical Repair',
    'Body & Paint',
    'Diagnostics & Electrical',
    'EV Services',
    'Others',
  ];

  toggleOther(event: Event) {
    this.otherChecked = (event.target as HTMLInputElement).checked;
    const ctrl = this.registrationForm.get('natureOfBusinessOthers');
    if (this.otherChecked) {
      ctrl?.setValidators([Validators.required]);
    } else {
      ctrl?.clearValidators();
      ctrl?.setValue('');
    }
    ctrl?.updateValueAndValidity();
  }

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: ApiService,
    public router: Router,
    private notify: NotificationService
  ) {
    this.registrationForm = this.fb.group({
      // Section A
      ownerName: ['', Validators.required],
      mobileNo: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      alternateMobileNo: [''],
      email: ['', [Validators.required, Validators.email]],

      // Section B
      branchName: ['', Validators.required],
      workshopName: ['', Validators.required],
      workshopType: ['', Validators.required],
      establishedYear: ['', Validators.required],
      gstNo: [''],
      workshopAddress: ['', Validators.required],
      stateId: ['', Validators.required],
      state: [''],
      cityId: ['', Validators.required],
      city: [''],
      pincode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
      landmark: [''],
      locationCode: ['', Validators.required],

      // Section C
      crashRepairs: [0],
      vehicleServiceBrands: this.fb.array([]),
      serviceBays: ['', Validators.required],
      vehicleInflow: ['', Validators.required],
      partsPurchaseVolume: ['', Validators.required],
      businessNatures: this.fb.array([]),
      natureOfBusinessOthers: [''],
      noOfMechanics: ['', Validators.required],
      managerName: ['', Validators.required],
      managerContact: [
        '',
        [Validators.required, Validators.pattern(/^[0-9]{10}$/)],
      ],
      partsStockValue: [''],

      // Section E
      expectations: this.fb.array([]),
      trainingRecruitmentSupport: [0],

      serviceInterests: this.fb.array([]),

      // Additional Workshops
      additionalWorkshops: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.bsConfig = {
      dateInputFormat: 'YYYY',
      minMode: this.minMode,
      maxDate: new Date(),
      containerClass: 'theme-default',
    };

    this.isLoading = true;

    this.http.get(`retailers/getStateList`).subscribe({
      next: (res: any) => {
        this.stateList = Array.isArray(res?.data) ? res.data : [];
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching profile:', error);
        this.stateList = []; // fallback to empty to avoid .length error in UI
        this.isLoading = false;
      },
    });
  }

  get additionalWorkshops(): FormArray {
    return this.registrationForm.get('additionalWorkshops') as FormArray;
  }

  getWorkshopGroup(index: number): FormGroup {
    return this.additionalWorkshops.at(index) as FormGroup;
  }

  addWorkshop() {
    this.additionalWorkshops.push(
      this.fb.group({
        branchName: ['', Validators.required],
        workshopAddress: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        pincode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
        landmark: [''],
        locationCode: ['', Validators.required],
        businessNatures: this.fb.array([]),
        noOfMechanics: ['', Validators.required],
        managerName: ['', Validators.required],
        managerContact: [
          '',
          [Validators.required, Validators.pattern(/^[0-9]{10}$/)],
        ],
        natureOfBusinessOthers: [''],
        partsStockValue: ['', Validators.required],
        stateId: ['', Validators.required],
        state: [''],
        cityId: ['', Validators.required],
        city: [''],
      })
    );
  }

  removeWorkshop(index: number) {
    this.additionalWorkshops.removeAt(index);
  }

  onCheckboxChange(name: string, field: string, event: any) {
    const formArray: FormArray = this.registrationForm.get(field) as FormArray;
    if (event.target.checked) {
      formArray.push(this.fb.control(name));
    } else {
      const i = formArray.controls.findIndex((x) => x.value === name);
      formArray.removeAt(i);
    }
  }

  onCheckbox(name: string, field: string, event: any, group: FormGroup): void {
    let formArray = group.get(field) as FormArray;

    if (!formArray) {
      // Optional safety fallback (though shouldn't be needed if form is built correctly)
      formArray = this.fb.array([]);
      group.addControl(field, formArray);
    }

    if (event.target.checked) {
      formArray.push(this.fb.control(name));
    } else {
      const i = formArray.controls.findIndex((x) => x.value === name);
      if (i >= 0) {
        formArray.removeAt(i);
      }
    }
  }

  onOtherSelect() {
    this.otherChecked = true;
    const ctrl = this.registrationForm.get('natureOfBusinessOthers');
    ctrl?.setValidators([Validators.required]);
    ctrl?.updateValueAndValidity();
  }

  sanitizeId(value: string): string {
    return 'business-' + value.replace(/\s+/g, '-').toLowerCase();
  }

  getExpectationId(value: string): string {
    return 'expectation-' + value.replace(/\s+/g, '-').toLowerCase();
  }

  get f() {
    return this.registrationForm.controls;
  }

  onStateChange(Event: any): void {
    const stateId = Event.target.value;
    if (stateId) {
      this.registrationForm.patchValue({ cityId: '' }); // reset city select
      this.cityList = []; // clear previous city list

      this.http.post('retailers/getCityList', { stateId }).subscribe({
        next: (res: any) => {
          if (res.code === 1 && res.data) {
            this.cityList = res.data;
          } else {
            this.cityList = [];
            this.notify.showSuccess(
              res.message || 'No cities found for this state',
              ''
            );
          }
        },
        error: (err) => {
          console.error('City fetch error:', err);
          this.notify.showError(
            'Failed to fetch cities. Please try again.',
            ''
          );
        },
      });
    }
  }

  onStateChanges(Event: any, index: number): void {
    const stateId = Event.target.value;
    if (!stateId) {
      this.cityLists[index] = [];
      this.additionalWorkshops.at(index).patchValue({ cityId: '' });
      return;
    }

    this.http.post('retailers/getCityList', { stateId }).subscribe({
      next: (res: any) => {
        if (res.code === 1 && res.data) {
          this.cityLists[index] = res.data;
        } else {
          this.cityLists[index] = [];
        }
        this.additionalWorkshops.at(index).patchValue({ cityId: '' });
      },
      error: () => {
        this.cityLists[index] = [];
      },
    });
  }

  onSubmit(): void {
    this.submitted = true;

    const formValue = this.registrationForm.value;
    const isoDate: Date = formValue.establishedYear;

    const selectedState = this.stateList.find(
      (state) => state.id == formValue.stateId
    );

    const selectedCity = this.cityList.find(
      (city) => city.id == formValue.cityId
    );

    const getCityName = (cityId: any, list: any[]) => {
      const foundCity = list.find((city) => city.id == cityId);
      return foundCity ? foundCity.city : null;
    };

    const additionalWorkshopsWithNames = (
      formValue.additionalWorkshops || []
    ).map((workshop, i) => {
      const wsState = this.stateList.find(
        (state) => state.id == workshop.stateId
      );
      const wsCity = getCityName(workshop.cityId, this.cityLists[i] || []);

      return {
        ...workshop,
        state: wsState?.state || null,
        city: wsCity || null,
      };
    });

    const payload = {
      ...formValue,
      establishedYear: isoDate ? isoDate.getFullYear().toString() : null,
      state: selectedState?.state || null,
      city: selectedCity?.city || null,
      additionalWorkshops: additionalWorkshopsWithNames, // updated workshops
    };

    if (this.registrationForm.invalid) {
      return;
    } else {
      this.isLoading = true;
      this.http.post('retailers/membershipApplication', payload).subscribe({
        next: (res) => {
          this.isLoading = false;

          if (res.code == 1) {
            this.notify.showSuccess(res.message, '');
            this.router.navigate(['/login']);
          } else {
            this.notify.showError(res.message, '');
          }
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Submission Error:', err);
          this.notify.showError('An error occurred. Please try again.', '');
        },
      });
    }
  }

  allowOnlyText(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow letters (A-Z, a-z) and space (code 32)
    if (
      !(
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode === 32
      )
    ) {
      event.preventDefault();
    }
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
}
